import { z } from 'zod';

export const createWorkOrderSchema = z.object({
  orderNumber: z.string()
    .trim()
    .min(1, 'El número de orden es requerido')
    .max(100, 'El número de orden no puede exceder 100 caracteres')
    .regex(/^[a-zA-Z0-9-_]+$/, 'El número de orden solo puede contener letras, números, guiones y guiones bajos'),
  productName: z.string()
    .trim()
    .min(1, 'El nombre del producto es requerido')
    .max(200, 'El nombre del producto no puede exceder 200 caracteres'),
  productCode: z.string()
    .trim()
    .max(50, 'El código de producto no puede exceder 50 caracteres')
    .optional()
    .or(z.literal('')),
  customer: z.string()
    .trim()
    .max(200, 'El nombre del cliente no puede exceder 200 caracteres')
    .optional()
    .or(z.literal('')),
  customerId: z.string()
    .uuid('ID de cliente inválido')
    .optional()
    .or(z.literal('')),
  projectId: z.string()
    .uuid('ID de proyecto inválido')
    .optional()
    .or(z.literal('')),
  customProjectName: z.string()
    .trim()
    .max(255, 'El nombre del proyecto no puede exceder 255 caracteres')
    .optional()
    .or(z.literal('')),
  partId: z.string()
    .trim()
    .min(1, 'El ID de pieza es requerido')
    .max(50, 'El ID de pieza no puede exceder 50 caracteres')
    .regex(/^[a-zA-Z0-9-_]+$/, 'El ID de pieza solo puede contener letras, números, guiones y guiones bajos'),
  quantity: z.number()
    .int('La cantidad debe ser un número entero')
    .min(1, 'La cantidad debe ser al menos 1')
    .max(1000000, 'La cantidad no puede exceder 1,000,000'),
  priority: z.number()
    .int('La prioridad debe ser un número entero')
    .min(0, 'La prioridad debe ser al menos 0')
    .max(10, 'La prioridad no puede exceder 10'),
});

export const addProcessSchema = z.object({
  processId: z.string()
    .min(1, 'Debe seleccionar un proceso'),
  operatorId: z.string()
    .optional()
    .or(z.literal('')),
  notes: z.string()
    .trim()
    .max(1000, 'Las notas no pueden exceder 1000 caracteres')
    .optional()
    .or(z.literal('')),
  processData: z.record(z.string(), z.string().max(500, 'El valor del campo no puede exceder 500 caracteres')),
});

export type CreateWorkOrderInput = z.infer<typeof createWorkOrderSchema>;
export type AddProcessInput = z.infer<typeof addProcessSchema>;
